import Cookies from 'universal-cookie';
import {
  CARE_DID_COOKIE_NAME,
  CZEN_SESSION_COOKIE_KEY,
  CZEN_VISITOR_COOKIE_KEY,
} from '../constants';

type CookieType = string | undefined;

export const getCookie = (cookieName: string): CookieType =>
  new Cookies().get(cookieName) ?? undefined;

export const getCzenVisitorId = (): CookieType => getCookie(CZEN_VISITOR_COOKIE_KEY);

export const getCzenSessionId = (): CookieType => getCookie(CZEN_SESSION_COOKIE_KEY);

export const getCareDeviceId = (): CookieType => getCookie(CARE_DID_COOKIE_NAME);
